// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5612":"39e7eba5","8089":"39e7eba5","9393":"63bea536"}[chunkId] + ".chunk.css";
};